import { PageHeader } from "@/components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Handshake } from "lucide-react";
import ProjectsTab from "@/pages/providers/ProjectsTab";
import ProvidersTab from "@/pages/providers/ProvidersTab";
import WorkOrdersTab from "@/pages/providers/WorkOrdersTab";
import FieldLogsTab from "@/pages/providers/FieldLogsTab";
import PayoutsTab from "@/pages/providers/PayoutsTab";
import ProjectDashboardTab from "@/pages/providers/ProjectDashboardTab";

// Projects & Service Providers — independent contractors engaged on work orders
// for a defined deliverable and paid against verified output. Kept entirely
// separate from Employee Master, Payroll, Attendance, Leave and Policies.
export default function ServiceProviders() {
  return (
    <div>
      <PageHeader overline="Projects" title="Projects & Service Providers" icon={Handshake}
        subtitle="Work orders, verified field output and commercial payouts for independent contractors — not employees." />
      <Tabs defaultValue="dashboard">
        <TabsList className="bg-slate-100 flex-wrap h-auto">
          <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="logs">Verify Logs</TabsTrigger>
          <TabsTrigger value="payouts">Payout Advices</TabsTrigger>
          <TabsTrigger value="work-orders">Work Orders</TabsTrigger>
          <TabsTrigger value="providers">Providers</TabsTrigger>
          <TabsTrigger value="projects">Projects</TabsTrigger>
        </TabsList>
        <TabsContent value="dashboard" className="mt-4"><ProjectDashboardTab /></TabsContent>
        <TabsContent value="logs" className="mt-4"><FieldLogsTab /></TabsContent>
        <TabsContent value="payouts" className="mt-4"><PayoutsTab /></TabsContent>
        <TabsContent value="work-orders" className="mt-4"><WorkOrdersTab /></TabsContent>
        <TabsContent value="providers" className="mt-4"><ProvidersTab /></TabsContent>
        <TabsContent value="projects" className="mt-4"><ProjectsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
